/*
 * Copyright (c) 2014-2023 Inovalon, Inc. All Rights Reserved.
 * This computer program is CONFIDENTIAL and a TRADE SECRET of Inovalon, Inc.
 * The receipt or possession of this program does not convey any rights to use, reproduce or disclose
 * its contents in whole or in part, without the specific written consent of Inovalon, Inc.
 * Any use, reproduction or disclosure of this program without the express written consent of Inovalon, Inc.
 * is a violation of the copyright laws and may subject you to criminal prosecution.
 */
import { injectable } from 'inversify'
import { ICoverageDiscoveryResponseApiClient } from './contracts'
import { injectProperty } from '../../arc/configuration/ServiceLocator'
import { IUserSessionMiddleware } from '../../arc/middleware/UserSessionMiddleware/contracts'
import { SettingsManager } from '../../configuration/SettingsManager'
import axios from 'axios'
import { IBaseResponse, IBaseResponseDetail, IBaseResponsesFilterCriteria } from '../CoverageDiscoveryResponseStateManager/contracts'
import { ErrorHelper } from '../../utils/ErrorHelper'

@injectable()
export class CoverageDiscoveryResponseApiClient implements ICoverageDiscoveryResponseApiClient {
	apiBaseUrl: string

	constructor() {
		this.apiBaseUrl = `${SettingsManager.REACT_APP_MAIN_API_BASE_URL().value}`
	}

	@injectProperty('IUserSessionMiddleware')
	private readonly userSessionMiddleware!: IUserSessionMiddleware

	getBaseResponseDetails(transactionResponseId: number, filter: IBaseResponsesFilterCriteria): Promise<IBaseResponseDetail[]> {
		const sort = `${filter.sortOrder === 'asc' ? '%2b' : '-'}${filter.sortField}`
		const params = `Sort=${sort}`
		const url = `${this.apiBaseUrl}/transactionresponseeligibilities/getbaseresponsedetails/${transactionResponseId}?&${params}`
		return this.userSessionMiddleware
			.loadSessionJwt()
			.then(token =>
				axios.get(url, {
					headers: {
						Authorization: `Bearer ${token}`,
					},
				}),
			)
			.then(response => response.data)

			.catch(error => {
				ErrorHelper.handleApiError(error)
			})
	}

	getResponse(transactionResponseEligibilityId: number): Promise<IBaseResponse> {
		const url = `${this.apiBaseUrl}/transactionresponseeligibilities/${transactionResponseEligibilityId}/GetResponse`
		return this.userSessionMiddleware
			.loadSessionJwt()
			.then(token =>
				axios.get(url, {
					headers: {
						Authorization: `Bearer ${token}`,
					},
				}),
			)
			.then(response => {
				return response.data
			})

			.catch(error => {
				ErrorHelper.handleApiError(error)
			})
	}
}
